import mirrorCreator from 'mirror-creator';

////////////////// CONSTANTS (edit) //////////////////

export const actionTypes = mirrorCreator([
  'CLEAR_ALBUM_MODAL_ERRORS',
  'CREATE_ALBUM_SUCCESS',
  'CREATE_ALBUM_FAILURE',
  'CREATE_PHOTO_SUCCESS',
  'CREATE_PHOTO_FAILURE',
  'DELETE_ALBUM_SUCCESS',
  'DELETE_PHOTO_SUCCESS',
  'FETCH_ALBUMS_FAILURE',
  'FETCH_ALBUMS_SUCCESS',
  'FETCH_PHOTOS_SUCCESS',
  'PHOTO_IS_UPLOADING',
  'SET_IS_FETCHING',
  'SET_IS_SAVING',
  'UPDATE_ALBUM_SUCCESS',
  'UPDATE_ALBUM_FAILURE',
]);
